module.exports = __webpack_public_path__ + "img/diapositiva-5-1.179d00eb.png";